<template>
    <div class="UserAgreement xi">
        <nh-com></nh-com>
        <div class="banner">
            <div class="banner-text">
                <h3>电话问诊说明</h3>
                <!-- <p>Ge Ren XI YI</p> -->
            </div>
        </div>
        <div class="agreement-box">
            <div class="agreement-tit">
                <h3>电话问诊说明</h3>
            </div>
            <div class="agreement-content">
                 <div class="disclaimer-container">
                        <div class="disclaimer-content">
                        <h3 class="title">一、情况说明</h3>
                        <p>您可以与医生通过电话，直接进行沟通交流，所以更适用于病情相对着急的患者。</p>
                        <p>需要特别注意的是，在您和医生通话之前，一定要完整的、详细的填写患者资料，以便医生对患者的病情有详细的了解。</p>                     
                        <h3 class="title">二、流程说明</h3>
                        <p>1.患者根据系统提示，填写详细的疾病信息，以及提交所需的相关图片、视频、文字资料；</p>
                        <p>2.患者支付成功以后，等待医生接诊；</p>
                        <p>3.医生接诊，并详细查看您提交的患者资料后，会主动与您取得联系，请您保持电话畅通；</p>
                        <p>4.通话过程中，医生给出详细的诊疗方案，请您务必做好记录，并打开手机录音功能。</p>
                        <p>5.一旦超过通话时长限制，您和医生将无法继续沟通，请您在有效时间内，把所有问题沟通明确。</p>
                        <div class="title">三、注意事项</div>
                        <p>1.您30分钟内未支付成功，该次电话问诊订单将会失效；</p>
                        <p>2.您提交的资料不符合医生专业要求，则会被其拒绝。被拒绝后，支付的费用原路退回；</p>
                        <p>3.您提交的资料有错误或者不准确，将会影响医生的最后诊断结果，甚至造成重大事故，故请您务必填写真实情况。</p>
                        <p>4.医生可以不接诊、或者拒绝接诊，届时您支付的费用，将会原路退回；</p>
                        <p>5.电话问诊可能由医生本人和团队同事共同完成，所以与您电话沟通者，未必是医生本人；</p>
                        <p>6.通话时长有限制，所以您务必要作好记录，打开手机录音功能。</p>
                        <p>7.一旦问诊完成，将不再支持退款。</p>
                        <div class="footer-space"></div>
                        </div>
                    </div>
            </div>
        </div>
        <ft-com></ft-com>
        <rt-bar></rt-bar>
    </div>
</template>

<script>
    import ftCom from '../../components/footer';
    import nhCom from "../../components/navheader";
    // import rtBar from "../../components/right";
    export default {
        name: "UserAgreement",
        components: {
            ftCom,
            nhCom,
            // rtBar
        },
    }
</script>

<style scoped>
    .UserAgreement{
        background: #f4f4f4;
    }
    .xi .banner{
        height: 116px;
        background: url("../../assets/img/jbk_banner.png")center no-repeat;
    }
    .banner-text{
        width: 1200px;
        margin: 0 auto;
    }
    .banner-text h3{
        padding-top: 25px;
        font-size: 26px;
        font-weight: normal;
        color: #ffffff;
    }
    .banner-text p{
        font-size: 18px;
        color: #ffffff;
    }
    .agreement-box {
        margin: 30px auto;
        width: 1200px;
        padding: 20px;
        box-sizing: border-box;
        background: #FFFFFF;
        border: 1px solid #e5e5e5;
    }
    .agreement-tit{
        padding: 10px 0 20px;
        border-bottom: 1px solid #e5e5e5;
    }
    .agreement-tit h3{
        font-size: 20px;
        color: #333333;
        text-align: center;
        font-weight: bold;
    }
    .agreement-content{
        padding: 25px 0;
    }
    .agreement-content p{
        text-indent: 28px;
        line-height: 2;
    }
    .agreement-content p.s-p{
        text-indent: 42px;
    }
    .agreement-content h4{
        text-indent: 28px;
        line-height: 1.7;
        padding: 15px 0;
    }
    .disclaimer-container {
  /* background-color: #f5f5f5; */
  min-height: 100vh;
  padding: 20px 0;
}

.disclaimer-content {
  background-color: #fff;
  padding: 24px;
  margin: 0 auto;
  /* max-width: 800px; */
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
  border-radius: 8px;
  color: #666;
  /* line-height: 1.6; */
}

.disclaimer-content p {
  margin: 12px 0;
  text-indent: 2em;
  text-align: justify;
}

.title {
  font-weight: 800;
  padding: 20px 0 10px 0;
  color: #333;
  border-bottom: 1px solid #eee;
  margin: 24px 0 16px 0;
}

.footer-space {
  width: 100%;
  height: 50px;
}
</style>

